
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/races-runners/runners",
      function () {
        return require("private-next-pages/races-runners/runners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/races-runners/runners"])
      });
    }
  